/**
 * Route detection utilities for navigation system
 */

export interface DetailRoute {
  section: string;
  id: string;
  baseSection: string; // e.g., '/configs'
}

/**
 * Check if a path is a detail route (has an ID parameter)
 */
export function isDetailRoute(path: string): boolean {
  const pathParts = path.split('/').filter(Boolean);
  // Detail routes have at least 2 parts: /section/id
  // Exclude 'new' as it's a creation route, not a detail route
  return pathParts.length >= 2 && pathParts[1] !== 'new';
}

/**
 * Parse a detail route to extract section and ID
 */
export function parseDetailRoute(path: string): DetailRoute | null {
  const pathParts = path.split('/').filter(Boolean);
  
  if (pathParts.length < 2 || pathParts[1] === 'new') {
    return null;
  }

  return {
    section: pathParts[0]!,
    id: pathParts[1]!,
    baseSection: `/${pathParts[0]!}`,
  };
}

/**
 * Check if a path is a list/main page for a section
 */
export function isListRoute(path: string): boolean {
  const pathParts = path.split('/').filter(Boolean);
  // List routes have exactly 1 part: /section
  return pathParts.length === 1;
}

/**
 * Get the base section from any path
 */
export function getBaseSection(path: string): string | null {
  const pathParts = path.split('/').filter(Boolean);
  if (pathParts.length === 0) return null;
  return `/${pathParts[0]}`;
}

